import { AccountStatus } from '../../constants';
import BaseApi from './BaseApi';

/**
 * 会員のメッセージ利用状況変更API。
 */
class UpdateCompanyAccountStatusApi extends BaseApi {
  async update(accountStatus: AccountStatus) {
    return await this.execute('updateCompanyAccountStatus', {
      method: 'POST',
      body: { accountStatus }
    }).then(({ status }) => status === 1);
  }
}

export default UpdateCompanyAccountStatusApi;
